












import Vue from 'vue'
export default Vue.extend ({
  props: {
    file: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  computed:{
    icon(){
      let icon = 'file-unknown'
      if(this.file.contentType === undefined){
        icon = 'folder-open'
      } else if( this.file.contentType.indexOf('image/') !== -1) {
        icon = 'file-image'
      } else {
        icon = 'file-text'
      }
      return icon
    },
    color(){
      let color = '#52c41a'
      if(this.file.contentType === undefined){
        color = '#ffe17b'
      } else if( this.file.contentType.indexOf('image/') !== -1 ) {
        color = '#71ce52'
      } else {
        color = '#92a8c1'
      }
      return color
    }
  },
  methods: {
    onChange(){
      this.$emit('check',this.file)
    },
    clickFile(){
      this.$emit('clickFile',this.file)
    },
    dblclickFile(){
      this.$emit('dblclickFile',this.file)
    }
  }
})
